import { connect } from 'react-redux';
import CoachList from './CoachList';

const mapStateToProps = ({ entities, selectedActivityGroups }) => {
  const { coachs, activityGroups } = entities;

  // total list of coach with matching group id
  const coachWithGroupIds = Object.values(coachs).map(coach => {
    const groupActivityIdList = Object.values(activityGroups)
      .filter(group => coach.activityIds.some(id => group.activityIdList.includes(id)))
      .map(group => group.id);
    return { ...coach, groupActivityIdList };
  });

  // list of coachs depending on filters
  const listCoachFiltered =
    selectedActivityGroups.length > 0
      ? coachWithGroupIds.filter(coach => coach.groupActivityIdList.some(id => selectedActivityGroups.includes(id)))
      : coachWithGroupIds;

  return {
    coachs: listCoachFiltered
  };
};

export default connect(mapStateToProps)(CoachList);



// WEBPACK FOOTER //
// ./src/components/CoachList/CoachListContainer.js